<template>
	<page style="height: 100vh; padding: 0">
		<module enable-flex>
			<div class="oss-head flex">
				<div class="logo flex-center-cross">
					<img src="@/submodule/assets/image/oss/oss_logo.png" alt="">
				</div>
				<div class="flex-between-center flex-grow">
					<div class="flex tab">
						<div class="item" :class="{'z-crt': currentTab == 1}" @click="currentTab = 1">全部文件</div>
						<div class="item" :class="{'z-crt': currentTab == 2}" @click="currentTab = 2">回收站</div>
					</div>
					<div v-show="currentTab == 1" class="search flex-center">
						<input v-model="fileKeyword" class="flex-grow" placeholder="搜索文件名、标签关键词" @keydown.enter="fileSearchHandle()">
						<i class="sf sf-search" @click="fileSearchHandle()"></i>
					</div>
				</div>
			</div>
			<div v-show="currentTab == 1" class="flex-grow flex">
				<div class="oss-aside">
					<menu-tree ref="tree" default-current @node-click="loadFiles"></menu-tree>
				</div>
				<div class="flex-grow flex-column">
					<div class="oss-top flex-between-center">
						<div class="crumb flex-center">
							<i class="icon sf sf-address"></i>
							<template v-for="(item, i) in crumbList">
								<i v-if="i" class="arrow sf sf-angle-right"></i>
								<span v-if="i == crumbList.length - 1">{{item.data.name}}</span>
								<a v-else @click="fileSearchState ? fileSearchHandle(_lastSearchKeyword) : $refs.tree.selectNode(item)">{{item.data.name}}</a>
							</template>
						</div>
						
						<div class="flex-center">
							<div class="total">共{{total.folder}}个文件夹、{{total.file}}个文件</div>
							<button class="upload" @click="uploadHandle"><i class="sf sf-upload"></i>上传文件</button>
							<button class="create" @click="createFolder"><i class="sf sf-plus"></i>新建目录</button>
						</div>
					</div>
					<div class="oss-handle flex-between-center">
						<div class="flex-center">
							<sub-checkbox :checked="allCheckState" @click="allCheckHandle">全选</sub-checkbox>
							<ins>|</ins>
							<a class="flex-center" style="color: #f55;" @click="deleteHandle()"><i class="sf sf-trash"></i>删除</a>
							<ins>|</ins>
							<a class="flex-center" @click="setKeyword()"><i class="sf sf-config"></i>设置关键词</a>
							<ins>|</ins>
							<a class="flex-center" @click="moveFile(true)"><i class="sf sf-copy"></i>复制</a>
							<ins>|</ins>
							<a class="flex-center" @click="moveFile()"><i class="sf sf-shift"></i>移动</a>
							<ins>|</ins>
							<a class="flex-center" @click="refreshHandle()"><i class="sf sf-refresh"></i>刷新</a>
						</div>
						<div class="flex-center">
							<sub-checkbox @change="$event => onlyImage = $event">只显示图片</sub-checkbox>
							<dl class="sort">
								<dt class="flex-center">
									<label>排序:</label>
									<div class="item flex-center">
										<span>{{currentSort.name}}</span>
										<i class="sf" :class="{'sf-sort-up': currentSort.type == 'DESC', 'sf-sort-down': currentSort.type == 'ASC'}"></i>
									</div>
								</dt>
								<dd>
									<div v-for="(item, i) in sortOptions" :key="i" class="item flex-center" @click="currentSort = item">
										<span>{{item.name}}</span>
										<i class="sf" :class="{'sf-sort-down': item.type == 'DESC', 'sf-sort-up': item.type == 'ASC'}"></i>
									</div>
								</dd>
							</dl>
						</div>
					</div>
					<div class="oss-main flex-grow">
						<empty v-if="compFilesList && compFilesList.length == 0"></empty>
						<div v-else-if="compFilesList" class="list flex-wrap">
							<div v-for="(item, i) in compFilesList" :key="`${item.fileType}-${item.id}`" class="item" :class="{'z-crt': currentFiles.includes(`${item.fileType}-${item.id}`)}" :title="item.filename" @click="clickHandle(item)" @dblclick="openHandle(item)">
								<div class="image">
									<sub-image :src="(item.fileType == 1 ? item.path : fileIcon[item.fileType]) || require('@/submodule/assets/image/oss/file.png')"></sub-image>
									<div v-if="item.id >= 0" class="handle flex-center-cross">
										<a v-if="item.fileType != 2" title="复制地址" @click.stop="clipboard(item.path)"><i class="sf sf-link"></i></a>
										<a v-if="item.fileType != 2" title="设置关键词" @click.stop="setKeyword(item)"><i class="sf sf-config"></i></a>
										<a title="复制" @click.stop="moveFile(true, item)"><i class="sf sf-copy"></i></a>
										<a title="移动" @click.stop="moveFile(false, item)"><i class="sf sf-shift"></i></a>
										<a title="删除" @click.stop="deleteHandle(item)"><i class="sf sf-trash"></i></a>
									</div>
								</div>
								<div class="name flex-center">
									<input v-if="renameFile == item" ref="rename" type="text" @click.stop @blur="renameHandle" @keydown.enter="renameHandle">
									<p v-show="renameFile != item" class="ellipsis">{{item.filename}}</p>
									<a v-if="item.id >= 0" v-show="renameFile != item" @click.stop="renameFile = item"><i class="sf sf-edit"></i></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-show="currentTab == 2" class="flex-grow flex-column">
				<div class="oss-handle flex-center-cross" style="border-bottom: none;">
					<a class="flex-center" style="color: #f55;" @click="completelyRemove()"><i class="sf sf-cross"></i>永久删除</a>
					<ins>|</ins>
					<a class="flex-center" @click="restoreHandle()"><i class="sf">&#xed79;</i>还原</a>
					<ins>|</ins>
					<a class="flex-center" @click="refreshHandle()"><i class="sf sf-refresh"></i>刷新</a>
				</div>
				<sub-table ref="recycleList" :paging="false">
					<sub-table-column
						type="selector"
					></sub-table-column>

          <sub-table-column
              label="文件"
              name=""
              width="300"
          >

            <!--文件类型 1：图片、2：文件夹、3：视频文件、4：Word文件、5：EXCEL文件、6：PPT文件、7：文本文件、8：压缩包、9：其他文件-->
            <template v-slot="{data}">
              <product-info v-if="data.fileType == 1" :image="data.path" :name="(data.filename||'') + ' ' + data.filename"></product-info>
              <span v-if="data.fileType == 2"><span style="color: #3A95E8">[文件夹]</span>{{data.filename}}</span>
              <span v-if="data.fileType == 3"><span style="color: #3A95E8">[视频文件]</span>{{data.filename}}</span>
              <span v-if="data.fileType == 4"><span style="color: #3A95E8">[Word文件]</span>{{data.filename}}</span>
              <span v-if="data.fileType == 5"><span style="color: #3A95E8">[EXCEL文件]</span>{{data.filename}}</span>
              <span v-if="data.fileType == 6"><span style="color: #3A95E8">[PPT文件]</span>{{data.filename}}</span>
              <span v-if="data.fileType == 7"><span style="color: #3A95E8">[文本文件]</span>{{data.filename}}</span>
              <span v-if="data.fileType == 8"><span style="color: #3A95E8">[压缩包]</span>{{data.filename}}</span>
              <span v-if="data.fileType == 9"><span style="color: #3A95E8">[其他文件]</span>{{data.filename}}</span>
            </template>
          </sub-table-column>

					<sub-table-column
						label="原位置"
						name="directory_name"
					></sub-table-column>

					<sub-table-column
						label="删除时间"
						name="delete_date"
					></sub-table-column>

				</sub-table>
			</div>
		</module>
		
		<sub-dialog ref="createFolder" title="新建目录" width="500" @resolve="createFolderHandle">
			<sub-form ref="createFolderForm">
				<sub-form-item type="hidden" name="parent_id"></sub-form-item>
				<sub-form-item type="input" label="目录名称" name="directory_name" required></sub-form-item>
			</sub-form>
		</sub-dialog>
		
		<sub-dialog ref="setKeyword" title="设置关键字" width="500" @resolve="setKeywordHandle">
			<sub-form ref="setKeywordForm">
				<sub-form-item type="hidden" name="file_ids"></sub-form-item>
				<sub-form-item type="textarea" :label="false" name="keywords" required placeholder="准确详细的关键词能让客户最快找到该图片。关键词总长度不能超过100字，每个关键词用”逗号“隔开。"></sub-form-item>
			</sub-form>
		</sub-dialog>
		
		<sub-dialog ref="moveFile" :title="`${moveCopy ? '复制' : '移动'}到`" width="400" height="600" @resolve="moveFileHandle">
			<menu-tree ref="moveFileTree" :leading="false"></menu-tree>
		</sub-dialog>
		
		<upload ref="upload"></upload>
		
		<div v-show="uploadWindowState" class="upload-rate">
			<div class="flex-between-center head">
				<p>{{uploadState[0] ? '正在上传' : '上传完成'}} ({{uploadState[1] + uploadState[2]}}/{{uploadFileList.length}})</p>
				<div class="flex-center">
					<a v-if="uploadWindowState == 1" @click="uploadWindowState = 2"><i class="sf sf-minus"></i></a>
					<a v-else @click="uploadWindowState = 1"><i class="sf">&#xe63e;</i></a>
					<a @click="uploadWindowState = 0"><i class="sf sf-cross"></i></a>
				</div>
			</div>
			<div v-show="uploadWindowState == 1" class="body">
				<div v-if="uploadState[1] + uploadState[2]" class="handle flex-between-center">
					<p><span style="color: #249b6a">{{uploadState[1]}}</span>个文件上传成功</p>
					<p><span style="color: #f55">{{uploadState[2]}}</span>个文件上传失败</p>
					<div class="flex-grow"></div>
					<a @click="uploadHandle">继续上传</a>
				</div>
				<ul>
					<li v-for="(file, i) in uploadFileList" :key="i" class="flex-center">
						<p class="name ellipsis">{{file.name}}</p>
						<div class="rate flex-grow">
							<div :style="{'width': `${file.rate}%`}"></div>
						</div>
						<p class="state">
							<span v-if="file.state == 1" style="color: #249b6a">上传成功</span>
							<span v-else-if="file.state == 2" style="color: #f55">上传失败</span>
							<span v-else style="color: #008bed">上传中</span>
						</p>
					</li>
				</ul>
			</div>
		</div>
	</page>
</template>

<script>
	import menuTree from './components/menu_tree.vue'
	import empty from '@/submodule/components/public/empty.vue'
	import global from '@/submodule/assets/script/function.js'
	import productInfo from "@/submodule/components/public/product_info.vue";
	import upload from "@/submodule/components/public/upload.vue";
	
	function separateFileId(ids) {
		let file = [], folder = [];
		ids.forEach(item => {
			let temp = item.split('-');
			if (temp[0] == 2) {
				folder.push(temp[1]);
			} else {
				file.push(temp[1]);
			}
		});
		
		return {
			file,
			folder
		}
	}
	
	export default {
		name: 'oss_manage',
		
		components: {
			productInfo,
			menuTree,
			empty,
			upload
		},
		
		data() {
			let sortOptions = [{
				name: '名称',
				type: 'DESC',
				value: 'file_name'
			}, {
				name: '名称',
				type: 'ASC',
				value: 'file_name'
			}, {
				name: '时间',
				type: 'DESC',
				value: 'create_date'
			}, {
				name: '时间',
				type: 'ASC',
				value: 'create_date'
			}];
			
			return {
				currentTab: 1,
				
				fileKeyword: '',
				fileSearchState: false,
				currentFolder: false,  // 搜索结果中当前打开的文件夹
				
				currentNode: false,
				
				filesList: '',
				fileIcon: {
					2: require('@/submodule/assets/image/oss/folder.png'),
					3: require('@/submodule/assets/image/oss/video.png')
				},
				currentFiles: [],
				
				moveCopy: false,
				onlyImage: false,
				sortOptions,
				currentSort: sortOptions[0],
				
				renameFile: '',
				
				uploadFileList: [],
				uploadWindowState: 0
			}
		},
		
		computed: {
			compFilesList() {
				if (this.filesList && this.onlyImage) {
					return this.filesList.filter(item => item.fileType == 1);
				}
				return this.filesList;
			},
			
			crumbList() {
				if (this.fileSearchState) {
					return [{
						data: {
							name: '全部搜索结果'
						}
					}].concat(this.currentFolder ? [{
						data: {
							name: this.currentFolder.filename
						}
					}] : []);
				}
				
				if (this.currentNode) {
					let node = this.currentNode,
						list = [];
					while (node) {
						list.unshift(node);
						node = node.expandData.parent;
					}
					return list;
				}
				
				return false;
			},
			
			total() {
				let list = this.filesList || [];
				let folder = list.filter(item => item.fileType == 2).length;
				
				return {
					folder,
					file: list.length - folder
				}
			},
			
			allCheckState() {
				return this.currentFiles.length > 0 && this.currentFiles.length == this.filesList.length;
			},
			
			uploadState() {
				return {
					0: this.uploadFileList.filter(item => item.state == 0).length,
					1: this.uploadFileList.filter(item => item.state == 1).length,
					2: this.uploadFileList.filter(item => item.state == 2).length
				}
			}
		},
		
		watch: {
			currentTab(val) {
				if (val == 2) {
					this.$refs.recycleList.load({
						url: '/oss/file/recycle'
					});
				}
			},
			
			filesList() {
				this.currentFiles = [];
			},
			
			onlyImage(val) {
				if (val) {
					this.currentFiles = this.currentFiles.filter(item => item.includes('1-'));
				}
			},
			
			currentSort() {
				this.refreshHandle();
			},
			
			renameFile(val) {
				if (val) {
					this.currentFiles = [`${val.fileType}-${val.id}`];
					this.$nextTick(() => {
						this.$refs.rename[0].value = val.fileType == 2 ? val.filename : val.filename.substring(0, val.filename.lastIndexOf('.'));
						this.$refs.rename[0].select();
					});
				}
			},
			
			uploadWindowState(val) {
				if (val == 0) {
					this.uploadFileList = this.uploadFileList.filter(item => item.state == 0);
				}
			}
		},
		
		created() {
			document.title = `图片空间 - ${this.$store.state.systemConfig.oms_system_name || this.$store.state.systemConfig.scs_system_name}`
		},
		
		methods: {
			loadFiles(node = this.currentNode, id) {
				if (node) {
					this.fileSearchState = false;
					this.currentFolder = false;
					this.currentNode = node;
					node.expand();
				}
				this.request({
					url: '/oss/file/directory_contents',
					data: Object.assign({
						directory_id: node ? node.data.id : id
					}, {
						file_sort_keyword: this.currentSort.value,
						file_sort_type: this.currentSort.type
					}),
					success: data => {
						this.filesList = data;
					}
				});
			},
			
			fileSearchHandle(last) {
				if (!this.fileKeyword.trim() && !last) {
					this.sub.$message({
						text: '请输入搜索内容'
					})
					return;
				}
				
				this._lastSearchKeyword = last || this.fileKeyword.trim();
				this.request({
					url: '/oss/file/search',
					data: Object.assign({
						keyword: last || this.fileKeyword.trim()
					}, {
						file_sort_keyword: this.currentSort.value,
						file_sort_type: this.currentSort.type
					}),
					success: data => {
						this.currentNode = false;
						this.currentFolder = false;
						this.$refs.tree.selectNode();
						this.fileSearchState = true;
						this.filesList = data || [];
					}
				});
			},
			
			clickHandle(item) {
				if (item.id < 0) {
					return;
				}
				let key = `${item.fileType}-${item.id}`;
				if (this.$shortcuts.ctrl) {
					if (this.currentFiles.includes(key)) {
						this.currentFiles.splice(this.currentFiles.indexOf(key), 1);
					} else {
						this.currentFiles.push(key);
					}
				} else {
					if (!this.currentFiles.includes(key) || this.currentFiles.length > 1) {
						this.$nextTick(() => {
							this.currentFiles = [key];
						});
					}
					this.currentFiles = [];
				}
			},
			
			openHandle(item) {
				if (item.fileType == 2) {
					if (this.fileSearchState) {
						this.loadFiles(false, item.id);
						this.currentFolder = item;
					} else {
						this.$refs.tree.selectNode(this.currentNode.expandData.children.find(node => node.data.id == item.id));
					}
				} else if (item.fileType == 1 || item.fileType == 3) {
					this.$preview({
						src: item.path
					});
				} else {
					window.open(item.path);
				}
			},
			
			uploadHandle() {
				if (this.fileSearchState && !this.currentFolder) {
					this.sub.$message({
						text: '无法在全部搜索结果中上传文件'
					});
					return;
				}
				
				let folderId = this.fileSearchState ? this.currentFolder.id : this.currentNode.data.id;
				
				this.$refs.upload.main({
					multiple: true,
					listener: data => {
						this.uploadFileList = this.uploadFileList.concat(data);
						this.uploadWindowState = 1;
					},
					success: data => {
						Promise.all(Array.from(data, item => {
							return new Promise(resolve => {
								new Promise(res => {
									if (item.fileObj.type.includes('image')) {
										let img = new Image();
										img.onload = function() {
											res(img);
										}
										img.src = item.path;
									} else {
										res();
									}
								}).then(data => {
									this.request({
										url: '/oss/file/save',
										data: {
											directory_id: folderId,
											file_real_name: item.fileObj.name,
											file_path: item.path,
											file_name: item.fileObj.name,
											file_size: item.fileObj.size,
											file_model: item.fileObj.name.substring(item.fileObj.name.lastIndexOf('.') + 1),
											width: data && data.width,
											height: data && data.height
										},
										success: resolve
									});
								})
							})
						})).then(() => {
							this.refreshHandle();
						});
					}
				});
			},
			
			createFolder() {
				if (this.fileSearchState && !this.currentFolder) {
					this.sub.$message({
						text: '无法在全部搜索结果中新建目录'
					});
					return;
				}
				
				this.$refs.createFolderForm.set({
					parent_id: this.fileSearchState ? this.currentFolder.id : this.currentNode.data.id,
					directory_name: ''
				});
				this.$refs.createFolder.open();
			},
			
			createFolderHandle(stop, next) {
				stop();
				this.$refs.createFolderForm.submit({
					url: '/oss/file/directory_add',
					rule: {
						directory_name: '请填写目录名称'
					},
					success: () => {
						next();
						if (this.currentNode) {
							this.currentNode.load();
						} else{
							this.$refs.tree.getRoot().load();
						}
						this.refreshHandle();
					}
				});
			},
			
			allCheckHandle(state) {
				if (state) {
					this.currentFiles = Array.from(this.filesList.filter(item => item.id >= 0), item => `${item.fileType}-${item.id}`);
				} else {
					this.currentFiles = [];
				}
			},
			
			deleteHandle(item) {
				if (!item && !this.currentFiles.length) {
					this.sub.$message({
						text: '请选择要删除的文件或文件夹'
					});
					return;
				}
				
				this.sub.$confirm({
					text: `确定要删除${item ? '该' : '已选'}文件或文件夹吗？`,
					resolve: () => {
						let id = separateFileId(item ? [`${item.fileType}-${item.id}`] : this.currentFiles);
						this.request({
							url: '/oss/file/remove',
							data: {
								fileIds: id.file.join(','),
								dirIds: id.folder.filter(item => item >= 0).join(',')
							},
							loading: true,
							success: () => {
								this.sub.$message({
									text: '删除成功'
								});
								if (this.currentNode) {
									this.currentNode.load();
								} else{
									this.$refs.tree.getRoot().load();
								}
								this.refreshHandle();
							}
						});
					}
				});
			},
			
			completelyRemove() {
				var list = this.$refs.recycleList.getRow('selected');
				if (!list.length) {
					this.sub.$message({
						text: '请选择要删除的文件'
					});
					return;
				}
				
				var fileIdArr = [];
				var dirIdArr = [];
				list.forEach(item => {
					var obj = item.data;
					if (obj.fileType == 2) {
						dirIdArr.push(obj.id);
					} else {
						fileIdArr.push(obj.id);
					}
				});
				
				this.sub.$confirm({
					text: '是否确定彻底删除选中的文件吗？',
					resolve: () => {
						this.request({
							url: '/oss/file/recycle_clear',
							data: {
								fileIds: fileIdArr.join(','),
								dirIds: dirIdArr.join(',')
							},
							loading: true,
							success: () => {
								this.sub.$message({
									text: '删除成功'
								});
								this.$refs.recycleList.update();
							}
						});
					}
				});
			},
			
			restoreHandle() {
				var list = this.$refs.recycleList.getRow('selected');
				if (!list.length) {
					this.sub.$message({
						text: '请选择要操作的记录'
					});
					return;
				}
				
				var fileIdArr = [];
				var dirIdArr = [];
				list.forEach(item => {
					var obj = item.data;
					if (obj.fileType == 2) {
						dirIdArr.push(obj.id);
					} else {
						fileIdArr.push(obj.id);
					}
				});
				
				this.sub.$confirm({
					text: '是否确定还原选中的文件吗？',
					resolve: () => {
						this.request({
							url: '/oss/file/recycle_back',
							data: {
								fileIds: fileIdArr.join(','),
								dirIds: dirIdArr.join(',')
							},
							loading: true,
							success: () => {
								this.sub.$message({
									text: '文件已还原'
								});
								this.$refs.recycleList.update();
							}
						});
					}
				});
			},
			
			setKeyword(item) {
				let ids = item ? [item.id] : separateFileId(this.currentFiles).file;

				if (!ids.length) {
					this.sub.$message({
						text: '请选择要设置关键词的文件'
					});
					return;
				}

				this.$refs.setKeywordForm.set({
					file_ids: ids.join(','),
					keywords: item.keywords||''
				});
				this.$refs.setKeyword.open();
			},

			setKeywordHandle(stop, next) {
				stop();
				this.$refs.setKeywordForm.submit({
					url: '/oss/file/set_keywords',
					success: () => {
						next();
						this.sub.$message({
							text: '设置成功'
						});
					}
				});
			},
			
			moveFile(copy, item) {
				this.moveCopy = copy;
				if (!item && !this.currentFiles.length) {
					this.sub.$message({
						text: `请选择要${this.moveCopy ? '复制' : '移动'}的文件或文件夹`
					});
					return;
				}
				
				this._moveFileId = separateFileId(item ? [`${item.fileType}-${item.id}`] : this.currentFiles);
				this.$refs.moveFileTree.clear();
				this.$refs.moveFile.open();
			},
			
			moveFileHandle(stop, next) {
				stop();
				
				if (!this.$refs.moveFileTree.getCurrent()) {
					this.sub.$message({
						text: `请选择要${this.moveCopy ? '复制' : '移动'}到哪个文件夹`
					});
					return;
				}
				
				this.request({
					url: this.moveCopy ? '/oss/file/copy' : '/oss/file/cut',
					data: {
						new_directory_id: this.$refs.moveFileTree.getCurrent().data.id,
						fileIds: this._moveFileId.file.join(','),
						dirIds: this._moveFileId.folder.join(',')
					},
					loading: true,
					success: () => {
						next();
						this.sub.$message({
							text: `${this.moveCopy ? '复制' : '移动'}成功`
						});
						!this.moveCopy && this.refreshHandle();
						this._moveFileId.folder.length && this.$refs.tree.getRoot().load();
					}
				});
			},
			
			refreshHandle() {
				this.filesList = '';
				this.fileSearchState ? this.currentFolder ? this.loadFiles(false, this.currentFolder.id) : this.fileSearchHandle(this._lastSearchKeyword) : this.loadFiles();
			},
			
			renameHandle: global.debounce(function() {
				if (!this.$refs.rename[0].value.trim()) {
					this.sub.$message({
						text: '名称不能为空'
					});
					this.renameFile = '';
					return;
				}
				this.request({
					url: this.renameFile.fileType == 2 ? '/oss/directory/rename' : '/oss/file/edit',
					data: {
						id: this.renameFile.id,
						[this.renameFile.fileType == 2 ? 'directory_name' : 'file_name']: this.$refs.rename[0].value.trim()
					},
					success: () => {
						this.renameFile.filename = this.$refs.rename[0].value.trim() + (this.renameFile.fileType == 2 ? '' : this.renameFile.filename.substring(this.renameFile.filename.lastIndexOf('.')));
					},
					complete: () => {
						this.renameFile = '';
					}
				});
			})
		}
	}
</script>

<style lang="stylus" scoped>
	.oss {
		&-head {
			height: 60px;
			color: #fff;
			background: #57A1E5;
			
			.logo {
				width: 220px;
				
				img {
					height: 45px;
					margin-left: 20px;
				}
			}
			
			.tab {
				.item {
					padding: 0 20px;
					margin-right: 10px;
					line-height: 60px;
					font-size: 16px;
					cursor: pointer;
					
					&:hover, &.z-crt {
						background: #80B7E9;
					}
				}
			}
			
			.search {
				width: 240px;
				height: 34px;
				border-radius: 2px;
				margin-right: 10px;
				background: #fff;
				
				input {
					height: 100%;
					padding-left: 10px;
					font-size: 13px;
				}
				
				.sf {
					width: 30px;
					line-height: 34px;
					font-size: 14px;
					text-align: center;
					color: #999;
					cursor: pointer;
				}
			}
		}
		
		&-aside {
			box-sizing: border-box;
			width: 220px;
			border-right: 1px solid #ddd;
		}
		
		&-top {
			height: 48px;
			padding: 0 10px 0 20px;
			
			.crumb {
				font-size: 12px;
				color: #444;
				
				.icon {
					margin-right: 6px;
					font-size: 18px;
					color: #777;
				}
				
				a {
					color: #1D8AEE;
					
					&:hover {
						text-decoration: underline;
					}
				}
				
				.arrow {
					margin: 0 3px;
				}
			}
			
			button {
				width: 102px;
				height: 30px;
				border: 1px solid #000;
				margin-left: 10px;
				font-size: 14px;
				
				.sf {
					margin-right: 5px;
					font-size: 16px;
				}
				
				&.upload {
					border-color: #7AD5AF;
					color: #249B6A;
					background: -webkit-linear-gradient(top,#EBFFF7,#D2F4E6);
					
					&:hover {
						background: -webkit-linear-gradient(top,#EBFFF7,#DFF9EE);
					}
				}
				
				&.create {
					border-color: #E1CB57;
					color: #C2880A;
					background: -webkit-linear-gradient(top,#FFFEF0,#FFF7D0);
					
					&:hover {
						background: -webkit-linear-gradient(top,#FFFEF0,#FFF9DD);
					}
				}
			}
			
			.total {
				font-size: 12px;
				color: #444;
			}
		}
		
		&-handle {
			height: 40px;
			border: 1px solid #C0E1FF;
			border-width: 1px 0;
			padding: 0 10px 0 20px;
			background: #F6FBFF;
			
			.sub-checkbox {
				margin-right: 12px;
			}
			
			a {
				height: 20px;
				font-size: 13px;
				color: #008BED;
				
				.sf {
					margin-right: 5px;
				}
			}
			
			ins {
				margin: 0 8px;
				color: #C0D8ED;
			}
			
			.sort {
				z-index: 9;
				position: relative;
				font-size: 12px;
				
				&:hover {
					dd {
						display: block;
					}
				}
				
				dt {
					height: 24px;
					border: 1px solid #ccc;
					padding-left: 6px;
					background: #fff;
					cursor: pointer;
				}
				
				dd {
					display: none;
					position: absolute;
					right: 0;
					top: 25px;
					border: 1px solid #ccc;
					background: #fff;
					
					.item:hover {
						background: #eee;
					}
				}
				
				.item {
					width: 50px;
					height: 24px;
					cursor: pointer;
					
					.sf {
						margin-left: 4px;
					}
				}
			}
		}
		
		&-main {
			overflow: auto;
			background: #F6F6F6;
			
			.list {
				padding: 0 10px 10px 0;
			}
			
			.item {
				width: 180px;
				margin-left: 10px;
				margin-top: 10px;
				background: #fff;
				cursor: pointer;
				outline: 2px solid rgba(0,0,0,0);
				transition: all .2s ease;
				user-select: none;
				
				&:hover {
					outline-color: #ccc;
					
					.image .handle {
						transform: translate(0,0);
					}
					
					.name {
						padding-bottom: 0;
						background: #eee;
					
						a {
							display: block;
						}
					}
				}
				
				&.z-crt {
					outline-color: #3A95E8;
					
					.name {
						padding-bottom: 0;
						line-height: 40px;
						color: #fff;
						background: #3A95E8;
					
						a {
							color: #fff;
						}
					}
				}
				
				.image {
					position: relative;
					height: 160px;
					padding: 10px;
					overflow: hidden;
					
					.handle {
						position: absolute;
						left: 0;
						right: 0;
						bottom: 0;
						height: 30px;
						padding: 0 10px;
						background: rgba(0,0,0,.75);
						transform: translate(0,100%);
						transition: all .3s ease;
						
						a {
							width: 28px;
							line-height: 30px;
							font-size: 20px;
							text-align: center;
							color: #fff;
							
							&:hover {
								background: #666;
							}
							
							&:nth-child(n+2) {
								margin-left: 5px;
							}
						}
					}
				}
				
				.name {
					box-sizing: border-box;
					height: 40px;
					padding: 0 10px 10px;
					line-height: 20px;
					text-align: center;
					transition: all .2s ease;
					
					a {
						display: none;
						margin-left: 5px;
						color: #008BED;
					}
					
					input {
						height: 30px;
						text-align: center;
						background: #fff;
					}
				}
			}
		}
	}
	
	.upload-rate {
		z-index: 99;
		position: fixed;
		right: 30px;
		bottom: 20px;
		width: 500px;
		border: 1px solid #1270c6;
		background: #fff;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
		
		.head {
			height: 45px;
			color: #fff;
			background: #57A1E5;
			
			p {
				padding-left: 20px;
				font-size: 15px;
				font-weight: bold;
			}
			
			a {
				width: 30px;
				margin-right: 10px;
				line-height: 30px;
				font-size: 16px;
				text-align: center;
				opacity: .6;
				
				&:hover {
					opacity: 1;
				}
			}
		}
		
		.body {
			position: relative;
			height: 300px;
			overflow: auto;
			
			.handle {
				position: sticky;
				top: 0;
				height: 34px;
				border-bottom: 1px solid #ffd493;
				padding: 0 10px;
				font-size: 13px;
				color: #333;
				background: #ffffe5;
				
				p {
					margin-right: 14px;
					
					span {
						margin-right: 4px;
						font-weight: bold;
					}
				}
				
				a {
					color: #008bed;
				}
			}
			
			li {
				height: 40px;
				border-bottom: 1px solid #eee;
				margin: 0 10px;
				
				.name {
					width: 200px;
					padding-left: 10px;
					font-size: 12px;
					color: #333;
				}
				
				.rate {
					height: 6px;
					border-radius: 3px;
					margin: 0 20px;
					background-color: rgb(92, 184, 92);
					background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.14902) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.14902) 50%, rgba(255, 255, 255, 0.14902) 75%, transparent 75%, transparent);
				}
				
				.state {
					width: 80px;
					font-size: 12px;
				}
			}
		}
	}
</style>